import {
  BarcodeIcon,
  MapPinIcon,
  CurrencyDollarIcon,
  PackageIcon,
} from "@phosphor-icons/react";
import { motion } from "framer-motion";
import {
  featureAnimate,
  featureInitial,
  titleAnimate,
  titleInitial,
} from "./animations";

const features = [
  {
    name: "Real-time Carrier Rates",
    description:
      "Our shipping rates module integrates with multiple carrier services to provide the best-value quotes when your customer is checking out.",
    icon: CurrencyDollarIcon,
  },
  {
    name: "Smart Geo-Routing",
    description:
      "We determine the closest distributor and warehouse location to fulfil your order, reducing delivery times and shipping costs.",
    icon: MapPinIcon,
  },
  {
    name: "Ugly Freight",
    description:
      "We provide real-time freight quotes for large, heavy, or oversized items and multi-package shipments.",
    icon: PackageIcon,
  },
  {
    name: "Consignment Tracking",
    description:
      "Keep your customers informed with integrated consignment tracking from a single, branded portal.",
    icon: BarcodeIcon,
  },
];

export default function ShippingCalculatorFeatures() {
  return (
    <div className="container mx-auto">
      <div className="px-6 pb-12 pt-12 md:pb-24">
        <div className="grid place-content-center gap-y-8 md:gap-x-6 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16">
          {features.map((feature, i) => (
            <motion.div
              initial={featureInitial}
              whileInView={featureAnimate(i)}
              viewport={{ once: true }}
              key={feature.name}
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-emerald-300/10 bg-linear-to-br from-emerald-950/80 to-emerald-950/10">
                <feature.icon
                  fixedWidth
                  className="h-6 w-6 text-emerald-500"
                  aria-hidden="true"
                />
              </div>

              <div className="mt-6">
                <h3 className="text-lg font-bold tracking-tight text-stone-50">
                  {feature.name}
                </h3>
                <p className="mt-2 text-sm text-balance text-emerald-300/75">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
